/**
 * Timezone constants - IANA timezone format
 * Supported timezones for user selection
 */
export const SUPPORTED_TIMEZONES = [
    { value: 'UTC', label: 'UTC - Global', iana: 'UTC' },
    { value: 'Asia/Kolkata', label: 'India - IST', iana: 'Asia/Kolkata' },
    { value: 'America/New_York', label: 'USA - New York (EST)', iana: 'America/New_York' },
    { value: 'America/Chicago', label: 'USA - Chicago (CST)', iana: 'America/Chicago' },
    { value: 'Europe/London', label: 'UK - GMT', iana: 'Europe/London' },
    { value: 'Europe/Berlin', label: 'Germany - CET', iana: 'Europe/Berlin' },
    { value: 'Asia/Dubai', label: 'UAE - GST', iana: 'Asia/Dubai' }
];

export const DEFAULT_TIMEZONE = 'UTC';

/**
 * Validates if a timezone is supported
 * @param {string} timezone - IANA timezone string
 * @returns {boolean} True if timezone is supported
 */
export function isValidTimezone(timezone) {
    if (!timezone) return false;
    return SUPPORTED_TIMEZONES.some(tz => tz.iana === timezone || tz.value === timezone);
}

/**
 * Gets timezone label by IANA value
 * @param {string} timezone - IANA timezone string
 * @returns {string} Display label or timezone itself
 */
export function getTimezoneLabel(timezone) {
    if (!timezone) return DEFAULT_TIMEZONE;
    const tz = SUPPORTED_TIMEZONES.find(t => t.iana === timezone || t.value === timezone);
    return tz ? tz.label : timezone;
}

